import {
  SET_LOADER,
  UNSET_LOADER
} from "../../constants/laoder/loaderConst";

const initial_state = {
  open: false,
  count: 0,
};

export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case SET_LOADER:
      const newCount = (state.count || 0) + 1;
      return { ...state, count: newCount, open: true };
    case UNSET_LOADER:
      const decreasedCount = (state.count || 0) - 1 < 0 ? 0 : (state.count || 0) - 1;
      return { ...state, count: decreasedCount, open: decreasedCount > 0 };
    default:
      return state;
  }
}
